export default "__VITE_ASSET__WUNJ_wpe__"